import React from 'react';
import Text from 'components/Text/Text';
import classNames from 'classnames';

interface IProps {
	translationKey: string;
	isActive: boolean;
	testId: string;
	onClick: () => void;
}

export const FormTab: React.FC<IProps> = ({ translationKey, isActive, testId, onClick }) => {
	const containerClasses = classNames(
		'px-4 py-2 border border-solid border-purple-02-new rounded-t text-base leading-5 whitespace-nowrap select-none',
		{
			'relative -mb-px border-b-white-00-new bg-white-00-new font-bold text-purple-07-new cursor-default':
				isActive,
			'bg-purple-01-new text-grey-10-new cursor-pointer hover:text-purple-07-new': !isActive,
		},
	);

	return (
		<div className={containerClasses} data-test={testId} onClick={isActive ? undefined : onClick}>
			<Text translationNameSpace="form" translationKey={translationKey} asFragment={true} />
		</div>
	);
};
